import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from '@utils/constants';

@Component({
  selector: 'app-support-channels',
  templateUrl: './support-channels.component.html'
})
export class SupportChannelsComponent implements OnInit {

  title = Constants.TITLE_CARD_SUPPORT_CHANNELS;
  wlConfig = this._configService.getConfigWhitelabel();
  suportChannels: any;

  constructor(
    public _dialogRef: MatDialogRef<SupportChannelsComponent>,
    private _configService: ConfigService
  ) { }

  ngOnInit() {
    this.suportChannels = this.wlConfig.contact.settingsSupportChannels;
    const channelTemp = [];
    if (this.wlConfig.contact && this.wlConfig.contact.settingsSupportChannels && this.wlConfig.contact.settingsSupportChannels.primary
      && this.wlConfig.contact.settingsSupportChannels.primary.length > 0) {
      this.wlConfig.contact.settingsSupportChannels.primary.forEach(element => {
        if (element.contact) {
          channelTemp.push(element);
        }
      });
      this.wlConfig.contact.settingsSupportChannels.primary = channelTemp;
    }
  }

  close() {
    this._dialogRef.close();
  }

}
